<template>
  <div class="control_bar top">
    <div class="search">
      <input
        type="text"
        class="search_field"
        placeholder="拠点ID、拠点名、ふりがな、電話番号、住所、補足情報から検索"
        v-model="inputValue"
      />
      <input
        type="button"
        :value="search"
        class="search_button"
        @click="placeFindAction"
      />
    </div>
    <controller
      :dispItems="dispItems"
      :allItems="places"
      :router="router"
      @remove="remove"
      @import="importModal"
      @exportFile="exportFile"
    >
    </controller>
    <div class="false_modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="close">
      </finishModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
    <div class="import_modal_window" v-if="showImportModal">
      <importModalWindow @close="closeModal" @import="importFile">
      </importModalWindow>
    </div>
  </div>
</template>

<script>
import controller from '../controller.vue'
import finishModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import importModalWindow from '../modalWindow/importModalWindow.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      inputValue: '',
      search: '検索',
      showFinishModal: false,
      finishWord: '',
      router: '/places/add',
      showloadingModal: false,
      showImportModal: false,
      records: [],
      csvData: [],
      confirmed: ''
    }
  },
  computed: {
    places() {
      return this.$store.state.places.locations
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    selectedLocationList() {
      return this.$store.state.places.selectedLocationList
    }
  },
  components: {
    controller,
    finishModalWindow,
    loadingModalWindow,
    importModalWindow
  },
  methods: {
    close(e) {
      this.showFinishModal = false
    },
    closeModal(e) {
      this.showImportModal = false
      this.showFinishModal = false
    },
    async remove(e) {
      let selectedLocationList = this.selectedLocationList.map(loc => {
        let userId = loc.userId
        let deviceId = loc.deviceId
        return {userId, deviceId}
      })
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'places/deleteLocations',
          selectedLocationList
        )
        this.$store.dispatch('places/clearSelectedLocationList')
        this.finishWord = '対象の拠点を削除しました。'
        this.showFinishModal = true
        // 削除ボタン押下時は詳細画面を初期化する
        if (location.pathname !== '/places') {
          this.$router.push('/places')
        }
        this.$emit('list-reload')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_170003
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0030') {
            this.finishWord =
              this.errorMsg.MSGCRC0030.name +
              this.errorMsg.MSGCRC0030.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.finishWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0298') {
            this.finishWord =
              this.errorMsg.MSGCRC0298.name +
              this.errorMsg.MSGCRC0298.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    },
    placeFindAction(event) {
      this.$emit('input-event', 0, this.inputValue)
      this.confirmed = this.inputValue
    },
    importModal(e) {
      this.records = e
      this.showImportModal = true
    },
    async importFile(e) {
      e = this.records
      this.showImportModal = false
      this.showloadingModal = true
      var createList = []
      for (let i = 0; i < e.length; i++) {
        let obj = {}
        let header = this.$store.state.error.exportTitle.placeTitle.replace(
          '\r\n',
          ''
        )
        let data = e[i].replace('\r', '')
        if (data !== header) {
          this.csvSplit(data)
          var csvArrayList = this.csvData
          this.csvData = []
          if (
            csvArrayList.length !==
            this.$store.state.error.importErrorNumber.importPlaceNumber
          ) {
            let eventNumber = this.$store.state.error.errorCode.errorCode_170007
            let eventType = 9
            let reason = 'MSGCRC0008'
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.finishWord =
              this.errorMsg.MSGCRC0008.name +
              this.errorMsg.MSGCRC0008.beforeValue +
              (i + 1) +
              this.errorMsg.MSGCRC0008.afterValue +
              'エラーコード：{' +
              eventNumber +
              '}'
            this.showFinishModal = true
            this.showloadingModal = false
            return
          }
          obj['userId'] = csvArrayList[0]
          obj['userName'] = csvArrayList[1]
          obj['pronunciation'] = csvArrayList[2]
          obj['phoneNumber'] = csvArrayList[3]
          obj['locationAddress'] = csvArrayList[4]
          const finalData = csvArrayList[5].replace(/[\r\n]/g, match => {
            if (match === '\r') {
              return ''
            } else {
              return ''
            }
          })
          obj['memo'] = finalData.replaceAll('\\n', '\n')
          obj['foothold'] = true
          obj['fileRowCount'] = String(i + 1)
          createList.push(obj)
        }
      }
      if (location.pathname !== '/places') {
        this.$router.push('../places')
      }
      try {
        await this.$store.dispatch('places/importLocations', createList)
        this.$emit('list-reload')
        this.finishWord = 'インポートしました。'
        this.showFinishModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_170009
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message.split(',')
          if (errorMessage[0] === 'MSGCRC0023') {
            this.finishWord =
              this.errorMsg.MSGCRC0023.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0023.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0024') {
            this.finishWord =
              this.errorMsg.MSGCRC0024.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0024.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0092') {
            this.finishWord =
              this.errorMsg.MSGCRC0092.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0092.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0098') {
            this.finishWord =
              this.errorMsg.MSGCRC0098.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0098.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0099') {
            this.finishWord =
              this.errorMsg.MSGCRC0099.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0099.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0100') {
            this.finishWord =
              this.errorMsg.MSGCRC0100.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0100.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0124') {
            this.finishWord =
              this.errorMsg.MSGCRC0124.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0124.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0130') {
            this.finishWord =
              this.errorMsg.MSGCRC0130.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0130.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0170') {
            this.finishWord =
              this.errorMsg.MSGCRC0170.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0170.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0171') {
            this.finishWord =
              this.errorMsg.MSGCRC0171.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0171.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0273') {
            this.finishWord =
              this.errorMsg.MSGCRC0273.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0273.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0206') {
            this.finishWord =
              this.errorMsg.MSGCRC0206.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0206.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0185') {
            this.finishWord =
              this.errorMsg.MSGCRC0185.name +
              (Number(errorMessage[1]) + 1) +
              this.errorMsg.MSGCRC0185.beforeValue +
              errorMessage[1] +
              this.errorMsg.MSGCRC0185.afterValue +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0264') {
            this.finishWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.finishWord =
              this.errorMsg.MSGCRC0031.name +
              this.errorMsg.MSGCRC0031.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage[0] + ' '
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    },
    csvSplit(line) {
      let c = ''
      let s = ''
      let before = ''
      let singleQuoteFlg = false
      let escapeFlg = false
      for (let i = 0; i < line.length; i++) {
        before = c
        c = line.charAt(i)
        if (c === ',' && !singleQuoteFlg) {
          this.csvData.push(s)
          s = ''
        } else if (c === ',' && singleQuoteFlg) {
          s = s + c
        } else if (c === '"') {
          if (before === '"' && escapeFlg) {
            s = s + c
            escapeFlg = false
          } else {
            if (i !== line.lengt - 1) {
              // 最終文字ではない場合
              if (line.charAt(i + 1) === '"' && singleQuoteFlg) {
                escapeFlg = true
              } else {
                singleQuoteFlg = !singleQuoteFlg
              }
            } else {
              singleQuoteFlg = !singleQuoteFlg
            }
          }
        } else {
          s = s + c
        }
      }
      if (line.charAt(line.length - 1) === ',') {
        // csvファイルの行の最終文字が , の場合
        this.csvData.push('')
      } else {
        this.csvData.push(s)
      }
    },
    async exportFile() {
      var selectedLocationIdList = this.selectedLocationList.map(location => {
        return {placeId: location.userId}
      })
      this.showloadingModal = true
      try {
        const params = {selectedLocationIdList: selectedLocationIdList}
        if (selectedLocationIdList.length === 0) {
          params.searchWord = this.confirmed ? this.confirmed : ''
        }
        await this.$store.dispatch('places/setExportData', params)

        const exportList = this.$store.state.places.exportData
        let result = this.$store.state.error.exportTitle.placeTitle
        for (let i = 0; i < exportList.length; i++) {
          for (let k of Object.keys(exportList[i])) {
            if (!exportList[i][k]) {
              exportList[i][k] = ''
            }
          }
          result +=
            exportList[i].placeId +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].placeName) +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].pronunciation) +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].phoneNumber) +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].locationAddress) +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].memo) +
            '\r\n'
        }
        if (result === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_170008
          let eventType = 9
          let reason = 'MSGCRC0006'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0006.name +
            this.errorMsg.MSGCRC0006.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        let csv = ''
        csv += result
        let link = document.createElement('a')
        let bom = new Uint8Array([0xef, 0xbb, 0xbf])
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([bom, csv], {type: 'text/csv'})
          window.navigator.msSaveOrOpenBlob(blob, '拠点一覧.csv')
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', '拠点一覧.csv')
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', '拠点一覧.csv')
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else {
          let eventNumber = this.$store.state.error.errorCode.errorCode_170005
          let eventType = 9
          let reason = 'MSGCRC0007'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0007.name +
            this.errorMsg.MSGCRC0007.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        window.URL.revokeObjectURL(link)
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_170006
        let eventType = 3
        let reason = ''
        if (error.response) {
          reason = 'MSGCRC0032 '
          this.finishWord =
            this.errorMsg.MSGCRC0032.name +
            this.errorMsg.MSGCRC0032.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
        this.showloadingModal = false
        return
      }
      this.showloadingModal = false
    },
    exportSetDoubleQuotation(value) {
      let c = ''
      let s = ''
      let doubleQuoteFlg = false
      // ダブルクォーテーションのエスケープ処理
      for (let i = 0; i < value.length; i++) {
        c = value.charAt(i)
        if (c === '"') {
          doubleQuoteFlg = true
          s = s + '"' + c
        }
        // 改行がある場合、文字列「￥n」に変換する
        else if (c === '\n') {
          s = s + '\\n'
        } else {
          s = s + c
        }
      }
      if (doubleQuoteFlg) {
        s = '"' + s + '"'
      }
      // カンマがある場合、ダブルクォーテーションで囲む
      if (s.indexOf(',') >= 0 && !doubleQuoteFlg) {
        return '"' + s + '"'
      }
      return s
    }
  }
}
</script>

<style scoped>
.search {
  margin: auto 0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/places/controlbar.vue